import { sunoCommsApi } from "../api-base";
import {
  OperatingHoursDay,
  OperatingHoursInput
} from "../types/operating-hours.type";

export const operatingHoursEndpoints = sunoCommsApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // Returns [] for an unconfigured location (never auto-creates rows).
    getOperatingHours: builder.query<OperatingHoursDay[], string>({
      query: (locationId) => `/operating-hours/?location_id=${locationId}`,
      providesTags: ["OperatingHours"]
    }),
    // Replaces the location's entire week atomically (all 7 days).
    updateOperatingHours: builder.mutation<
      OperatingHoursDay[],
      OperatingHoursInput
    >({
      query: (body) => ({
        url: `/operating-hours/`,
        method: "PUT",
        body
      }),
      invalidatesTags: ["OperatingHours"]
    })
  })
});

export const { useGetOperatingHoursQuery, useUpdateOperatingHoursMutation } =
  operatingHoursEndpoints;
